import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-performance__head" }
const _hoisted_2 = { class: "as-performance__body" }
const _hoisted_3 = { class: "as-vs" }
const _hoisted_4 = { class: "as-vs__line" }
const _hoisted_5 = { class: "as-vs-line-item" }
const _hoisted_6 = { class: "as-vs-line-item__ball" }
const _hoisted_7 = { class: "as-icon" }
const _hoisted_8 = {
  key: 0,
  class: "as-vs__text"
}
const _hoisted_9 = { class: "as-bold" }
const _hoisted_10 = { class: "as-green" }
const _hoisted_11 = { class: "as-team-history" }
const _hoisted_12 = { class: "as-team-history__item" }
const _hoisted_13 = { class: "as-team-history as-none-border" }
const _hoisted_14 = { class: "as-team-history__item" }

import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import FootballTeamItem from "../FootballTeamItem.vue";
import IconPerformance from "~src/components/icons/foot_stats/IconPerformance.vue";
import TeamItem from "./TeamItem.vue";
import StaticsTeam from "./StaticsTeam.vue";
import IBall from "~src/components/icons/incident/IBall.vue";
import type { IFootyStats, ITeam, IStatsParent } from "~src/interfaces/footystats";
import { getPercentByPoint } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  modifyClass?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Performance',
  props: {
    match: {},
    modifyClass: { default: "" },
    footyStats: { default: null },
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const homePoint = computed<number>(() => {
  return homeTeamLastX.value?.stats?.seasonPPG_overall ?? 0;
});

const awayPoint = computed<number>(() => {
  return awayTeamLastX.value?.stats?.seasonPPG_overall ?? 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-performance ${_ctx.modifyClass}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconPerformance),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, " Phong độ - Đội nào sẽ dành chiến thắng? ", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modifyClass: "as-vertical",
        showName: false,
        homePoint: homePoint.value,
        awayPoint: awayPoint.value
      }, null, 8, ["footyStats", "match", "homePoint", "awayPoint"]),
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "as-vs__tile" }, "Phong độ tổng quan", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-vs-line-item__main" }, null, -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-vs-line-item__percent" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(IBall)
              ])
            ])
          ])
        ]),
        (homePoint.value > 0 || awayPoint.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(homePoint.value > awayPoint.value ? _ctx.footyStats?.home_name : _ctx.footyStats?.away_name), 1),
              _cache[3] || (_cache[3] = _createTextVNode(" có ")),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getPercentByPoint)(homePoint.value, awayPoint.value)) + "%", 1),
              _cache[4] || (_cache[4] = _createTextVNode(" tốt hơn xét về")),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "as-bold" }, "Điểm số mỗi trận đấu", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modeTeam: "as-away",
        modifyClass: "as-vertical",
        showName: false,
        homePoint: homePoint.value,
        awayPoint: awayPoint.value
      }, null, 8, ["footyStats", "match", "homePoint", "awayPoint"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(TeamItem, {
          teamMode: "home",
          footyStats: _ctx.footyStats,
          homeTeamInfo: _ctx.homeTeamInfo,
          awayTeamInfo: _ctx.awayTeamInfo
        }, null, 8, ["footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(StaticsTeam, {
          teamMode: "home",
          footyStats: _ctx.footyStats,
          homeTeamInfo: _ctx.homeTeamInfo,
          awayTeamInfo: _ctx.awayTeamInfo
        }, null, 8, ["footyStats", "homeTeamInfo", "awayTeamInfo"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(TeamItem, {
          teamMode: "away",
          footyStats: _ctx.footyStats,
          homeTeamInfo: _ctx.homeTeamInfo,
          awayTeamInfo: _ctx.awayTeamInfo
        }, null, 8, ["footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(StaticsTeam, {
          teamMode: "away",
          footyStats: _ctx.footyStats,
          homeTeamInfo: _ctx.homeTeamInfo,
          awayTeamInfo: _ctx.awayTeamInfo
        }, null, 8, ["footyStats", "homeTeamInfo", "awayTeamInfo"])
      ])
    ])
  ], 2))
}
}

})